import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const STORAGE_KEY = "zasya-cookie-consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          role="region"
          aria-label="Cookie preferences"
          className="fixed bottom-5 left-5 z-[55] w-[calc(100vw-2.5rem)] max-w-md rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.25 }}
          data-testid="cookie-banner"
        >
          <h2 className="font-display text-sm font-bold text-slate-900">Your privacy preferences</h2>
          <p className="mt-1.5 text-xs leading-relaxed text-slate-600">
            We use essential storage to run this site and would like to use privacy-conscious
            analytics to improve it. Read our{" "}
            <Link to="/privacy" className="font-semibold text-blue-700 underline">
              Privacy Policy
            </Link>
            .
          </p>
          <div className="mt-4 flex gap-2.5">
            <button
              type="button"
              onClick={() => choose("all")}
              className="btn-primary flex-1 !px-4 !py-2 !text-xs"
              data-testid="cookie-accept-all"
            >
              Accept all
            </button>
            <button
              type="button"
              onClick={() => choose("essential")}
              className="btn-secondary flex-1 !px-4 !py-2 !text-xs"
              data-testid="cookie-essential-only"
            >
              Essential only
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
